// extracted by css-extract-rspack-plugin
var _1 = "h";
var _2 = "bb";
var _3 = "g";
var _4 = "be";
var _5 = "bc";
var _6 = "f";
export { _1 as "content", _2 as "customUserComm", _3 as "inner", _4 as "userCommunicationTemplateComponent", _5 as "userCommunicationTemplateModalComponent", _6 as "wrapper" }
